import { ExpertBankAccount } from "./ExpertBankAccount.model"
import { ExpertRegion } from "./ExpertRegion.model"

export const CourtType = Object.freeze({
  DISTRICT: { title: 'Районный', value: 0}, 
  WORLD: { title: 'Мировой', value: 1 }
})

export class ExpertCourt {
  constructor(json) {
    this.id = json?.id ?? ""

    this.title = json?.title ?? ""
    this.alias = json?.alias ?? ""

    this.bankAccount = json?.bankAccount ? new ExpertBankAccount(json?.bankAccount ?? null) : null
    this.courtRegion = new ExpertRegion(json?.courtRegion ?? null)

    this.type = json?.type ?? null
  }
}